<template>
  <b-card title="سفارش های رها شده">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="3">
                <b-form-group
                  label="محصول"
                  label-for="ProductId"
                >
                  <z-product
                    v-model="filterOptions.ProductId"
                    :clearable="true"
                    :multiple="false"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="از تاریخ"
                  label-for="FromDate"
                >
                  <date-picker
                    v-model="filterOptions.FromDate"
                    placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="تا تاریخ"
                  label-for="ToDate"
                >
                  <date-picker
                    v-model="filterOptions.ToDate"
                    placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >
                فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          :busy="loading"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updateorder', params: { id: data.value } }"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(User)="data">
            <b-link v-if="data.value">
              <b-media
                vertical-align="center"
                style="align-items: center;"
              >
                <template #aside>
                  <b-avatar :src="data.value.Image" />
                </template>
                <span
                  class="font-weight-bold d-block text-nowrap"
                  style="color: #6e6b7b;"
                >
                  {{ data.value.Name }} {{ data.value.Family }}
                </span>
              </b-media>
            </b-link>
          </template>

          <template #cell(OrderDetails)="data">
            <span
              v-for="(item, index) in data.value"
              :key="index"
            >
              {{ item.Product.Title }}
              <span v-if="item.Quantity > 1">({{ item.Quantity }})</span>
              <span v-if="index < data.value.length - 1">، </span>
            </span>
          </template>

          <template #cell(PayPrice)="data">
            {{ data.value | price }}
          </template>

          <template #cell(LastActivity)="data">
            <span v-if="data.item.OrderDetails && data.item.OrderDetails.length">
              {{ data.item.OrderDetails[0].ModifiedAt || data.item.OrderDetails[0].CreatedAt | date }}
            </span>
          </template>

          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-link :to="{ name: 'updateorder', params: { id: data.item.Id } }">
                <feather-icon
                  icon="EditIcon"
                  size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import ZProduct from '@/tools/product.vue'

export default {
  name: 'AbandonedOrder',
  components: {
    ZProduct,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
        ProductId: null,
        IsAbandoned: true,
        FromDate: null,
        ToDate: null,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'OrderDetails',
          label: 'محصولات',
        },
        {
          key: 'PayPrice',
          label: 'مبلغ',
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      this.$http.post(this.$api.order.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
